export const codeForBackendJS = (
  clientCredentials: Record<string, string>[] | undefined
): string =>
  `const hashedUserId = require('crypto') // crypto is part of nodejs
  .createHmac('sha256', '${
    clientCredentials ? clientCredentials[0]['clientSecret'] : ''
  }')
  .update('ACTUAL_USER_ID')
  .digest('base64');`;

export const codeForBackendPy = (
  clientCredentials: Record<string, string>[] | undefined
): string =>
  `import hmac
import hashlib
import base64
hashedUserId = base64.b64encode(hmac.new( '${
    clientCredentials ? clientCredentials[0]['clientSecret'] : ''
  }'.encode('utf-8'), 
            'ACTUAL_USER_ID'.encode('utf-8'),
             hashlib.sha256).digest())`;

export const codeForFrontendJS = (
  clientCredentials: Record<string, string>[] | undefined
): string =>
  `new NotificationAPI({
  root: '...',
  clientId: '${
    clientCredentials
      ? (clientCredentials as Record<string, string>[])[0]['clientId']
      : '...'
  }',
  userId: 'ACTUAL_USER_ID',
  userIdHash: 'HASHED_USER_ID',
  popupPosition: PopupPosition.BottomLeft
});`;
